<template>
  <modal :modal-key="'unsubscribe_modal'"
         :class-style="'modal--welcomeback modal--unsubscribe'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ userDetails.username }}, {{ getTranslations.home_modals_unsubscribe_choice_in_level }}</h1>
      <img :src="getTranslations.project_config_modal_img" alt="">
    </template>
    <template slot="body">
      {{ getTranslations.home_modals_unsubscribe_choice_if_you }}
    </template>
    <template slot="footer">
      <a>
        <div class="btn2 btn2--small btn2--outline" @click="unsubscribe">
          {{ getTranslations.home_modals_unsubscribe_choice_unsubscribe }}
        </div>
      </a>
      <a>
        <div class="btn2 btn2--std btn2--small" @click="noUnSubscribe">
          {{ getTranslations.home_modals_unsubscribe_choice_cancel }}
        </div>
      </a>
    </template>
  </modal>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
import Resubscribe from './Resubscribe';
import ResubscribeQuestionViaSms from './ResubscribeQuestionViaSms';

export default {
  // modal_unsubscribe.html
  name: 'unsubscribe',
  components: {
    Modal,
    Resubscribe,
    ResubscribeQuestionViaSms,
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForSettings',
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapActions('common', [
      'optoutCall',
    ]),
    noUnSubscribe() {
      this.$emit('close');
    },
    unsubscribe() {
      this.optoutCall().then(() => {
        this.getUserLoginDetails().then(() => {
          if (this.userDetails.subscribed) {
            this.noUnSubscribe(); // close modal
          } else {
            // eslint-disable-next-line
            if (this.hasReSubOption()) {
              this.$emit('close');
              if (this.subAndUnsubViaSMS && (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS')) {
                this.storeModalForSettings(ResubscribeQuestionViaSms);
              } else {
                this.storeModalForSettings(Resubscribe);
              }
            } else {
              this.noUnSubscribe(); // close modal
            }
          }
        });
      });
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>

<style type="text/css">
  a {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/modals/Unsubscribe.vue